import 'intersection-observer';
import '@babel/polyfill';
import './components/picturefill';
import Choices from 'choices.js';
import objectFitImages from 'object-fit-images';
import sal from 'sal.js';
import * as helpers from './helpers';
import autocomplete from './components/autocomplete';
import StratisMessage from './components/message';
import initPreloader from './components/preloader';
import Dropdown from './components/dropdown';
import Megamenu from './components/megamenu';
import ResponsiveEvent from './components/responsive-event';
import linkExternalNewWindow from './components/new_window';
import Tooltip from './components/accesstooltip';
import Agreement from '../components/agreement/agreement';
import {
    dateManagement,
    enableTimePicker,
} from './components/stratis_datepicker';
import initDateRangeController from './components/stratis_daterange';
import initGalleries from './components/galleries';
import initSelectCondition from './components/select-condition';
import toTop from '../components/go-to-top/go-to-top';
import flashInfoLocalstorage from '../components/flash-info/flash-info';
import publicationCoverflowSlider from '../components/alire/alire-coverflow';
import managePageImage from '../components/page-image/page-image';
import initStratisMenu from '../components/stratis-menu/stratis-menu';
import DirectionAware from './components/direction-aware';
import drawChart from './components/chart';
import SlideToggler from './components/slideToggler';
import TabsCordion from './components/tabsCordion';
import initMulticategoies from './components/categories';
import initCarousels from './components/carousel';
import hero from '../components/hero/sld-1/hero';
import initMultiselect from '../components/multiselect/multiselect';
import initLocaliserPopup from './components/localiser-popup';
import buttonsStateToggle from './components/buttons-state-toggle';
import projectVideo from '../components/projects/projects';
import Geocode from './components/geocode';
import SearchContent from './components/search-content';
import BreakCarousel from '../components/break-carousel/break-carousel';
// import Readspeaker from '../components/read-speaker/read-speaker';
import Weather from '../components/weather/weather';
import mapArea from '../components/location/location';
import partialCore from './components/partial-core';
import likeButton from './components/like-button';

// Refactored
import FixedElement from './components/fixed-element';
import OpenHeaderPopup from './components/open-header-popup';
import FormFactory from './components/form/form-factory';
import splitStringWithBr from './components/split-string';

const event = new ResponsiveEvent();

document.addEventListener('DOMContentLoaded', () => {
    hero();
    initCarousels();
    initStratisMenu();
    objectFitImages('img');
    toTop();
    sal();
    linkExternalNewWindow();
    flashInfoLocalstorage();
    autocomplete();
    dateManagement();
    initDateRangeController();
    enableTimePicker();
    managePageImage();
    drawChart('.chart');
    mapArea();
    helpers.objectIsPolyfill();
    initLocaliserPopup();
    partialCore();
    splitStringWithBr('.js-inline-bg');
    const openPopup = new OpenHeaderPopup();

    const header = FixedElement.create('.header:not(.-map) .header-bar', {
        mode: 'offset',
        offset: 10,
        onScroll: () => {
            // Close open dropdowns when scrolling
            Object.values(window.dropdownList).forEach((el) => {
                if (el.selector) {
                    const parent = document.querySelector('.header-bar');
                    if (parent && parent.contains(el.selector) && helpers.hasClass(el.selector, '-is-open')) {
                        el.close();
                    }
                }
            });
        },
    });

    // const tooltipSettings = {
    //     objs: '.js-tooltip',
    //     tooltipClassName: 'access-tooltip',
    //     toolTipBetween: 15,
    //     toolTipUp: false,
    //     mouse: true,
    //     tempDelay: 6000,
    //     useAriaDP: false,
    //     useEscClose: true,
    // };
    //
    // accessTooltip(tooltipSettings);
    initMulticategoies();
    initMultiselect();
    buttonsStateToggle();
    projectVideo();
    publicationCoverflowSlider();
    initSelectCondition();
    likeButton();

    // Forms Handler
    const _forms = FormFactory.create();

    const geo = new Geocode();
    const electedName = new SearchContent('.contact-elected', {
        search: ['#keyword1', '#select1'],
        searchButton: '.filters__buttons .filters__button.-submit',
        item: '.contact__item',
    });

    const searchPopupHandler = () => {
        $(document).on('afterShow.fb', (e, instance, slide) => {
            const fancyboxContent = instance.current.$content[0];
            const shouldAccessibilityInit = fancyboxContent && helpers.hasClass(fancyboxContent, 'search-popup');
            const tabbableElements = helpers.getFocusableElements(fancyboxContent, false);

            const tabHandler = (keyEvent) => {
                // Focus trap

                if (keyEvent.key.toLowerCase() === 'tab'
                    && tabbableElements.length
                    && Object.is(document.activeElement, tabbableElements[tabbableElements.length - 1])) {
                    tabbableElements[0].focus();
                }

                // Closing by "Escape" button pressing

                if (keyEvent.key.toLowerCase() === 'escape' || keyEvent.key.toLowerCase() === 'esc') {
                    $.fancybox.close();
                }
            };

            $.fancybox.defaults.afterClose = () => {
                document.removeEventListener('keydown', tabHandler);
            };

            const accessibilityInnit = shouldAccessibilityInit ? (
                document.addEventListener('keydown', tabHandler)
            ) : null;
        });
    };

    searchPopupHandler();

    // Initializing click roll in the sidebar of map
    window.addEventListener('openPopup', () => {
        const clickRoll = new Dropdown('.click-roll', {
            wrapperClass: 'click-roll',
            dropdownClass: 'click-roll__block',
            btnClass: 'click-roll__toggle',
            closeOnOutsideClick: false,
            openTypeSlide: true,
            isWrapContent: true,
        });
    });

    document.createElement('picture');

    // Create DefaultMenu with settings
    const menu = new Megamenu('.mnv-menu', {
        menu: {
            type: 'aside',
        },
        overlay: {
            show: false,
        },
        rebuildMenu: [
            {
                breakpoints: ['smartphone', 'tablet'],
                selector: '.menu-floating',
                callback: (el, wrap) => wrap.insertBefore(el, wrap.querySelector('.mnv-menu__list')),
            },
            {
                breakpoints: ['smartphone', 'tablet'],
                selector: '.one-click-wrapper',
                callback: (el, wrap) => helpers.insertAfter(el, wrap.querySelector('.mnv-menu__list')),
            },
        ],
        beforeOpenMenu: () => {
            openPopup.closePopup();
        },
    });

    const direct = new DirectionAware('.js-direction');

    const moreFilters = new Dropdown('.filters__dropdown', {
        wrapperClass: 'filters__dropdown',
        dropdownClass: 'filters__dropdown-block',
        btnClass: 'filters__dropdown-toggle',
        closeOnOutsideClick: false,
        openTypeSlide: true,
        focusTrap: false,
    });

    const sidebarSearch = new Dropdown('.search-block__listitem.is-dropdown', {
        wrapperClass: 'search-block__listitem.is-dropdown',
        dropdownClass: 'search-block__sublist-wrapper',
        btnClass: 'search-block__link.is-toggle',
        closeOnOutsideClick: false,
        openTypeSlide: true,
        focusTrap: false,
    });

    const menuFloating = new Dropdown('.menu-floating', {
        wrapperClass: 'menu-floating',
        dropdownClass: 'menu-floating__list',
        closeOnOutsideClick: false,
        btnClass: 'menu-floating__btn',
        opened: ['desktop'],
        focusTrap: false,
        clickRoll: true,
    });

    const headerSearchForm = document.querySelector('.header-search__form');
    const headerSearchToggle = document.querySelector('.header-search__toggle');

    if (headerSearchForm && headerSearchToggle) {
        const searchDropdown = new Dropdown('.header-search', {
            wrapperClass: 'header-search',
            dropdownClass: 'header-search__form',
            btnClass: 'header-search__toggle',
            closeOnOutsideClick: true,
        });
    }

    const checkboxDropdown = new Dropdown('.checkbox-dropdown', {
        wrapperClass: 'checkbox-dropdown',
        dropdownClass: 'checkbox-dropdown__block',
        btnClass: 'checkbox-dropdown__toggle',
        closeOnOutsideClick: false,
        focusTrap: false,
        onInit(instance) {
        },
        afterOpen(instance) {
        },
    });

    const oneClick = new Dropdown('.one-click-panel', {
        wrapperClass: 'one-click-panel',
        dropdownClass: 'one-click-panel__section',
        closeBtn: true,
        closeBtnClass: 'one-click-panel__close',
        outsideToggle: true,
        outsideToggleId: 'js-one-click-toggle',
        focusTrap: ['desktop'],
        beforeOpen: () => {
            if (window.responsive === 'desktop') {
                helpers.addClass(document.body, '-overflow-hidden');
            }
        },
        afterClose: () => {
            if (window.responsive === 'desktop') {
                helpers.removeClass(document.body, '-overflow-hidden');
            }
        },
    });

    // Turn on slideToggle
    const toggleItems = [...document.querySelectorAll('[data-sd-content]')];
    toggleItems.forEach((toggleItem) => {
        const toggleItemName = toggleItem.dataset.sdContent;

        const toggleTriggers = [...document.querySelectorAll(`[data-sd-trigger="${toggleItemName}"]`)];
        const item = toggleTriggers.length > 0 && new SlideToggler(toggleItem);

        if (item) {
            toggleTriggers.forEach((toggleTrigger) => {
                const action = toggleTrigger.getAttribute('data-sd-action') || 'toggle';
                toggleTrigger.addEventListener('click', () => helpers.executeIfFunction(item[action].bind(item)));
            });
        }
    });

    // Add class to ancestor
    // Find ancestor and add to it a class
    // Just add to element data attribute with selector and class: data-add-ancestor="container-wrapper,-dark"
    const addClassToAncestors = [].slice.call(document.querySelectorAll('[data-add-ancestor]'));
    addClassToAncestors.forEach((child) => {
        const [selector, cls] = child.getAttribute('data-add-ancestor')
            .split(',', 2);
        const ancestor = helpers.findAncestor(child, selector);
        if (ancestor && cls) {
            helpers.addClass([ancestor], cls);
        }
    });

    // Add this block with class <span class="ghost" data-remove-section="class"></span>
    const removeEmptySection = [].slice.call(document.querySelectorAll('[data-remove-section]'));
    removeEmptySection.forEach((child) => {
        const el = child.getAttribute('data-remove-section');
        const ancestor = helpers.findAncestor(child, el);
        if (ancestor) {
            ancestor.parentNode.removeChild(ancestor);
        }
    });


    // Disable ctrl+v (paste) event for target elements
    const disablePasteElArray = [...document.querySelectorAll('.js-disable-paste')];

    let ctrlDown = false;
    const ctrlKey = 17;
    const cmdKey = 91;
    const vKey = 86;
    const cKey = 67;

    document.addEventListener('keydown', (e) => {
        if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = true;
    });

    document.addEventListener('keyup', (e) => {
        if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = false;
    });

    disablePasteElArray.forEach((disablePaste) => {
        disablePaste.addEventListener('keydown', (e) => {
            if (ctrlDown && (e.keyCode === vKey || e.keyCode === cKey)) {
                e.preventDefault();
                return false;
            }
        });
    });


    // Init choices autocomplete
    const autocompleteElArray = [...document.querySelectorAll('.js-select-autocomplete')];

    autocompleteElArray.forEach((el) => {
        const _ = new Choices(el, {
            removeItemButton: false,
            itemSelectText: '',
            renderChoiceLimit: -1,
            searchResultLimit: 4,
            noResultsText: 'Aucun résultat',
            noChoicesText: 'Aucun choix',
            fuseOptions: {
                threshold: 0,
                location: 0,
                distance: 50,
            },
        });
    });

    // Readpseaker - See doc in read-speaker.js
    /*
    const initRS = new Readspeaker('article.container-wrapper .heading', {
        insertPosition: 'beforebegin',
        customerId: '10375',
        readId: null,
        readClass: 'heading__content,site-content',
        config: {
            general: {
                usePost: true,
            },
            ui: {
                disableDetachment: true,
                displayDownload: true,
                tools: {
                    translation: true,
                },
            },
        },
        preserveScript: '.click-roll, .localiser',
        ignoreContent: '.gallery, .media-element__wrapper, .localiser, .pager',
    });
    */

    const initWeather = new Weather('.weather .container', {
        langTempMax: 'Température maximum',
        langTempMin: 'Température minimum',
        langTo: 'à',
        langToday: 'Aujourd\'hui',
        langWeather: 'Météo',
        langWind: 'Vent',
        langMonday: 'Lundi',
        langTuesday: 'Mardi',
        langWednesday: 'Mercredi',
        langThursday: 'Jeudi',
        langFriday: 'Vendredi',
        langSaturday: 'Samedi',
        langSunday: 'Dimanche',
    });

    const inputsToRemoveSpaces = ['.header-search__form-input input, #search-input'];

    inputsToRemoveSpaces.forEach((fieldSelector) => {
        const fieldsArray = [...document.querySelectorAll(fieldSelector)];
        fieldsArray.forEach((field) => {
            field.value = field.value.trim();
        });
    });
});

window.addEventListener('load', () => {
    initPreloader();
    initGalleries();

    // Fix cross domain restrictions https://learn.javascript.ru/cross-window-communication
    const domain = document.querySelector('.site-wrapper').getAttribute('data-domain');

    if (domain) {
        document.domain = window.location.hostname === 'localhost' ? 'localhost' : domain;
    }

    const carousel = new BreakCarousel();

    $.fancybox.defaults.beforeLoad = (fancybox) => {
        if (fancybox.current.type === 'iframe' && fancybox.current.opts.$orig[0].hasAttribute('title')) {
            fancybox.current.opts.iframe.attr.title = fancybox.current.opts.$orig[0].getAttribute('title');
        }
    };

    const filterToggles = document.querySelectorAll('.filters .filters__dropdown-toggle');

    if (filterToggles) {
        [...filterToggles].forEach((toggle) => {
            toggle.addEventListener('click', () => {
                if (toggle.textContent === 'Voir tous les filtres') {
                    toggle.textContent = 'Moins de filtres';
                } else {
                    toggle.textContent = 'Voir tous les filtres';
                }
            });
        });
    }

    const mainTabs = document.querySelector('.main-tabs');

    const homeTabs = new TabsCordion('.home-page .main-tabs', {
        onlyState: 'tabs',
        prefix: 'main-tabs',
        titleSelector: '.tabs__title',
        options: {
            class: {
                panel: 'main-tabs__column',
            },
        },
    });

    const checkResponsiveHomeTabs = () => {
        return window.responsive === 'smartphone' ? homeTabs.init() : homeTabs.destroy();
    };

    window.addEventListener('responsive', () => {
        console.log('current breakpoint: ', window.responsive);

        if (mainTabs) {
            checkResponsiveHomeTabs();
        }
    });

    if (mainTabs) {
        checkResponsiveHomeTabs();
    }

    const siteImages = [].slice.call(document.getElementsByTagName('img')); // Edge fix

    siteImages
        .filter(img => !img.hasAttribute('data-ofi-src')) // Exclude object-fit images
        .filter(img => img.src.indexOf('.svg') === -1) // Exclude svg since they can return 0 sometimes
        .forEach((img) => {
            if (!img.naturalHeight) {
                helpers.addClass(img, '-broken-img');
                img.setAttribute('height', 0);
            }
        });

    const tabs = new TabsCordion('.tabs', {
        onlyState: 'tabs',
        titleSelector: '.tabs__title',
        onInit: () => {
            initMultiselect();
        },
    });

    const clickRoll = new Dropdown('.click-roll', {
        wrapperClass: 'click-roll',
        dropdownClass: 'click-roll__block',
        btnClass: 'click-roll__toggle',
        closeOnOutsideClick: false,
        openTypeSlide: true,
        isWrapContent: true,
        clickRoll: true,
        arrows: false,
        infobar: false,
        afterInit: (instance) => {
            const tabsInside = [...instance.querySelectorAll('.tabs')];
            tabsInside.forEach((tab) => {
                const tabsInsideDropdown = new TabsCordion(tab, {
                    onlyState: 'tabs',
                    titleSelector: '.tabs__title',
                    onInit: () => {
                        initMultiselect();
                    },
                },
                'tabs',
                true);
            });
        },
    });

    const shareBlock = new Dropdown('.share-block', {
        wrapperClass: 'share-block',
        dropdownClass: 'share-block__listitems',
        btnClass: 'share-page__button',
        focusTrap: false,
    });

    const messages = new StratisMessage('.message');

    Object.values(window.dropdownList)
        .forEach((el) => {
            if (el.toggler && helpers.hasClass(el.toggler.parentElement, '-is-open')) {
                el.open();
            }
        });

    const heroContent = document.querySelectorAll('.hero-item__content');

    if (heroContent) {
        [...heroContent].forEach((item) => {
            const heroLink = item.querySelector('.hero-item__link');
            const heroTitle = item.querySelector('.hero-item__title');

            heroLink.addEventListener('mouseover', () => {
                item.classList.add('-hover');
                heroTitle.classList.add('-hover');
                heroLink.classList.add('-hover');
            });

            item.addEventListener('mouseleave', () => {
                item.classList.remove('-hover');
                heroTitle.classList.remove('-hover');
                heroLink.classList.remove('-hover');
            });
        });
    }

    const accountRemovePopup = document.querySelector('.account-remove__popup');

    if (accountRemovePopup) {
        const btnNotRemove = accountRemovePopup.querySelector('.account-remove__popup-close');

        if (btnNotRemove) {
            btnNotRemove.addEventListener('click', (e) => {
                e.preventDefault();
                const btnClosePopup = accountRemovePopup.querySelector('.fancybox-close-small');
                if (btnClosePopup) {
                    btnClosePopup.click();
                }
            });
        }
    }

    const clearButton = document.querySelector('.js-clear-input');

    if (clearButton) {
        clearButton.addEventListener('click', () => {
            const parent = helpers.findAncestor(clearButton, 'header-search__form-input');
            const input = parent.querySelector('input');
            input.value = '';
        });
    }

    const vote = document.querySelector('.vote');

    if (vote) {
        const voteToggle = vote.querySelector('.vote__toggle');

        if (voteToggle) {
            const voteAdditional = vote.querySelector('.vote__additional');
            const voteBlock = vote.querySelector('.vote__block');

            voteToggle.addEventListener('click', (evt) => {
                evt.preventDefault();
                voteToggle.classList.toggle('vote__toggle--active');
                voteAdditional.classList.toggle('vote__additional--hidden');
                voteBlock.classList.toggle('vote__block--hidden');
            });
        }
    }

    $('[data-type="iframe"]').fancybox({
        toolbar: false,
        smallBtn: true,
        iframe: {
            preload: false,
        },
        btnTpl: {
            close: `
                    <button data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                        <svg role="img" aria-label="{{CLOSE}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <title>{{CLOSE}}</title>
                            <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/>
                        </svg>
                    </button>
                `,
        },
        afterShow() {
            const iframe = document.querySelector('.fancybox-iframe');

            if (window.location !== window.parent.location) {
                const closeBtnArray = [...document.querySelectorAll('.fancybox-close-small')];

                closeBtnArray.forEach((closeBtn) => {
                    closeBtn.style.display = 'none';
                });
            }

            if (iframe) {
                iframe.onload = () => {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                    if (iframeDoc) {
                        setTimeout(() => {
                            const pager = iframeDoc.querySelector('.pager.-single');

                            if (pager) {
                                pager.parentNode.removeChild(pager);
                            }

                            // if (iframeDoc.body) {
                            //     iframeDoc.body.classList.add('-in-iframe');
                            //     const tarteaucitronIframe = iframeDoc.querySelector('.tarteaucitronAlertBigBottom');
                            //     if (tarteaucitronIframe) {
                            //         tarteaucitronIframe.style.display = 'none';
                            //     }
                            // }

                            const links = [...iframeDoc.querySelectorAll('a')];

                            links.forEach((link) => {
                                const target = link.getAttribute('target');
                                let href = link.getAttribute('href');
                                const isFancyboxGallery = 'fancybox' in link.dataset;
                                const isFancyboxIframe = 'fancybox' in link.dataset && link.dataset.type === 'iframe';

                                if (target === '_blank') {
                                    link.removeAttribute('rel');
                                    link.removeAttribute('title');
                                    link.classList.remove('link-external');
                                } else {
                                    link.setAttribute('target', '_top');
                                }

                                link.addEventListener('click', () => {
                                    if (target === '_blank'
                                        || href === ''
                                        || href === '#'
                                        || link.getAttribute('data-srcset')
                                        || (isFancyboxGallery && !isFancyboxIframe)
                                        // eslint-disable-next-line no-script-url
                                        || (href === 'javascript:;' && !isFancyboxIframe)
                                        || helpers.hasClass(link, 'no-redirect')
                                    ) {
                                        return;
                                    }

                                    if (isFancyboxIframe) {
                                        href = link.getAttribute('data-src');
                                    }

                                    window.location.href = href;
                                });
                            });
                        }, 1000);
                    }
                };
            }
        },

        afterClose(instance) {
            if (window.location !== window.parent.location) {
                const closeBtn = document.querySelector('.data-fancybox-close');
                closeBtn.style.display = 'block';
            }
        },
    });

    const agreement = new Agreement();
    // const cards = [...document.querySelectorAll('.js-card')];
    // cards.forEach((card) => {
    //     const btn = card.querySelector('.js-card-add');
    //     const removeEvent = () => {
    //         const clickRolls = [...card.querySelectorAll('.click-roll')];
    //         if (clickRolls && clickRolls.length) {
    //             clickRolls.forEach((roll) => {
    //                 const buttonRemove = roll.querySelector('.js-card-remove:not(.event)');
    //                 helpers.addClass(buttonRemove, 'event');
    //                 if (buttonRemove) {
    //                     buttonRemove.addEventListener('click', () => {
    //                         roll.parentNode.removeChild(roll);
    //                     });
    //                 }
    //             });
    //         }
    //     };
    //
    //     removeEvent();
    //     btn.addEventListener('click', () => {
    //         const btnRemove = '<button type="button" class="js-card-remove"><span class="ghost">Remove card</span></button>';
    //         const id1 = helpers.getUniqId();
    //         const id2 = helpers.getUniqId();
    //         const id3 = helpers.getUniqId();
    //         const newCard = `
    //             <dl class="click-roll">
    //                 <dt><button type="button" class="click-roll__toggle">Title</button>${btnRemove}</dt>
    //                 <dd class="click-roll__block" data-response="Réponse :">
    //                 <div class="flex-row">
    //                     <div class="col-xs-12">
    //                         <div class="form__field-wrapper">
    //                             <label for="select${id1}">Select</label>
    //                             <select name="select${id1}" id="select${id1}">
    //                                 <option value="0">- Sélectionner -</option>
    //                                 <option value="1">Option 1</option>
    //                                 <option value="2">Option 2</option>
    //                             </select>
    //                         </div>
    //                     </div>
    //                     <div class="col-xs-12">
    //                         <div class="form__field-wrapper">
    //                             <label for="input${id2}">Input</label>
    //                             <input type="text" name="input${id2}" id="input${id2}" value="" placeholder="lorem">
    //                         </div>
    //                     </div>
    //                     <div class="col-xs-12">
    //                         <div class="form__field-wrapper">
    //                             <label for="select${id3}">Select</label>
    //                             <select name="select${id3}" id="select${id3}">
    //                                 <option value="0">- Sélectionner -</option>
    //                                 <option value="1">Option 1</option>
    //                                 <option value="2">Option 2</option>
    //                             </select>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 </dd>
    //             </dl>`;
    //
    //         btn.insertAdjacentHTML('afterEnd', newCard);
    //         clickRoll.checkBeforeInit();
    //         removeEvent();
    //     });
    // });


    const tooltip = new Tooltip();

    $('[data-map="localiser"]').fancybox({
        animationEffect: 'zoom',
        autoFocus: true,
        backFocus: true,
        trapFocus: false,
        clickOutside: 'close',
        idleTime: false,
        buttons: [
            'thumbs',
            'close',
        ],
        btnTpl: {
            close: `
                    <button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">
                        <svg role="img" aria-label="{{CLOSE}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <title>{{CLOSE}}</title>
                            <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/>
                        </svg>
                    </button>
                `,
        },
        type: 'iframe',
        afterLoad() {
            const btnClose = document.querySelector('.fancybox-button.fancybox-button--close');
            const fancyContent = document.querySelector('.fancybox-content');

            if (btnClose && fancyContent) {
                fancyContent.insertAdjacentElement('afterbegin', btnClose);
            }
        },
    });

    const pager = document.querySelector('.pager');

    if (pager) {
        const pagerStart = pager.querySelector('.pager__item.-start');
        const pagerEnd = pager.querySelector('.pager__item.-end');

        if (pagerStart) {
            const pagerStartSpanItem = pagerStart.querySelector('span');

            if (pagerStartSpanItem) {
                const nextPager = pager.querySelector('.pager__item:nth-child(4)');
                nextPager.classList.add('-active');
            }
        }

        if (pagerEnd) {
            const pagerEndSpanItem = pagerEnd.querySelector('span');

            if (pagerEndSpanItem) {
                const nextPager = pager.querySelector('.pager__item:nth-child(7)');
                nextPager.classList.add('-active');
            }
        }
    }

    const mainLogos = document.querySelectorAll('.header-bar__logo .logo');

    [...mainLogos].forEach((mainLogo) => {
        mainLogo.removeAttribute('target');
    });

    const btnsRemoveFovorites = [...document.querySelectorAll('.js-stratis-reaction')];
    btnsRemoveFovorites.forEach((btn) => {
        btn.addEventListener('click', () => {
            const container = btn.parentElement.parentElement;
            if (helpers.hasClass(btn, 'js-page-remove ')) {
                container.removeChild(btn.parentElement);
            }
            if (!container.firstElementChild) {
                container.parentElement.parentElement.removeChild(container.parentElement);
            }
        });
    });

    const jsStratisReation = [...document.querySelectorAll('.js-stratis-reaction')];
    jsStratisReation.forEach((btn) => {
        btn.addEventListener('click', ({ target }) => {
            if (helpers.hasClass(target, '-is-active')) {
                const addAttr = target.getAttribute('data-title-add');
                target.innerHTML = addAttr;
                target.setAttribute('title', addAttr);
            } else {
                const removeAttr = target.getAttribute('data-title-remove');
                target.innerHTML = removeAttr;
                target.setAttribute('title', removeAttr);
            }
        });
    });

    // Delete tarteaucitron cookies one time after JS updating
    const cookiesDeleteRequestNumber = 1;
    const isCookiesDeleted = localStorage.getItem(`cookies-deleted-${cookiesDeleteRequestNumber}`);
    const cookiesToDelete = ['tarteaucitron', 'tartaucitron'];

    if (!isCookiesDeleted && tarteaucitron) {
        cookiesToDelete.forEach((cookie) => {
            helpers.deleteCookie(cookie);
        });

        localStorage.setItem(`cookies-deleted-${cookiesDeleteRequestNumber}`, true);
    }
});
